import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const ServiceLogs = (props) => {
    return (
        <div className='detail__specs-service-logs'>
            <h3 className='detail__specs-heading'><TranslationText tKey='sandhills.tradepubwebsite.mvc.servicelogs' /></h3>
            {props.ServiceLogs && props.ServiceLogs.length > 0 && props.ServiceLogs.map(serviceLogVM =>
                <div className='detail__specs-wrapper'>
                    <div className='detail__specs-label'>
                        {serviceLogVM.Type}
                    </div>
                    <div className='detail__specs-value'>
                        {serviceLogVM.Files && serviceLogVM.Files.length > 0 && serviceLogVM.Files.map(serviceLog =>
                            <a className='detail__specs-link' target='_blank' content="noindex" href={serviceLog.Url} aria-label={serviceLog.Name + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                {serviceLog.Name}</a>)}
                    </div>
                </div>)}
        </div>
    );
};

export default ServiceLogs;